(function($) {
    
    const customFileInput = document.querySelectorAll('.custom-file-input')
    
    if(customFileInput) {
        
        customFileInput.forEach(el => {
            const input = el.querySelector('input[type="file"]')
            const button = el.querySelector('.file-button')
            const content = el.querySelector('.file-content')
            const text = el.querySelector('.file-name')
            const defaultText = text.innerText
            
            const form = el.closest('form')
            
            const clearInput = document.createElement('button')
            clearInput.classList.add('remove-file')
            clearInput.innerHTML = "Remover"
            clearInput.type = 'button'
            
            input.setAttribute('tabindex', '-1')
            
            button.addEventListener('click', () => input.click())
            
            function clear() {
                input.value = ''
                text.innerHTML = defaultText ? defaultText : 'Nenhum arquivo selecionado'
                
                clearInput.remove()
            }
            
            form.addEventListener('wpcf7invalid', event => {
                const fieldName = input.name
                const fieldError = 
                    event && event.detail && event.detail.apiResponse && event.detail.apiResponse.invalid_fields
                    ? event.detail.apiResponse.invalid_fields.find(el => el.field === fieldName)
                    : null
                
                if(fieldError) {
                    alert(`Erro ao enviar arquivo: ${fieldError.message}`)
                }
            })
            
            form.addEventListener('wpcf7mailsent', () => clear())
            clearInput.addEventListener('click', () => clear())
            
            input.addEventListener('change', function() {
                if(this.files.length) {
                    const textValue = this.files.length > 1 
                        ? `${this.files.length} arquivos escolhidos` 
                        : this.files[0].name
                        
                    text.innerHTML = textValue
                    content.appendChild(clearInput)
                        
                    return
                }
                
                clear()
            })
        })
    }

})(jQuery);
(function($) {
  
    $(window).on('load', function () {
      
        $('footer .menu-item-has-children').each(function(el) {
            function openSubmenu(element) {
                element.find('a[href="#"]').addClass('open')
                
                const submenu = element.find('.menu')
                const submenuHeight = submenu[0].scrollHeight
                
                submenu.height(submenuHeight)
            }
            
            function closeSubmenu(element) {
                element.find('a[href="#"]').removeClass('open')
                element.find('a[href="#"').attr('data-submenu', null)
                
                const submenu = element.find('.menu')
                
                submenu.attr('style', null)
            }
            
            $(this).find('> a').on('click', event => {
                const mainLink = $(this).find('a[href="#"]')
                
                if(mainLink) {
                    event.preventDefault()
                    $(this).find('.menu').css('height') == '0px' 
                        ? openSubmenu($(this)) 
                        : closeSubmenu($(this))
                }
            })
            
            $(this).find('> a').on('mouseenter', () => {
                openSubmenu($(this))
            })
            
            $(this).find('.menu').on('mouseenter', () => {
                openSubmenu($(this))
            })
            
            $(this).find('> a').on('mouseleave', () => {
                closeSubmenu($(this))
            })
            
            $(this).find('.menu').on('mouseleave', () => {
                closeSubmenu($(this))
            })
        })
    
    });

})(jQuery);
(function($) {
    // Menu
    function menuToggle(e) {
        $('.mobile-menu-button').toggleClass('open');
        $('.main-navbar').toggleClass('open');
        $('body').toggleClass('no-scroll');
    }
    $('.mobile-menu-button').on('click', menuToggle);
    
    function submenuToggle(e) {
      
      const isMobile = window.innerWidth < 1200
      
      if (!isMobile) {
        return;
      }
      
      e.preventDefault()
      
      if ( $( $(this).attr('href') ).length ) {
        menuToggle();
        closeMenuOnClick();
        return;
      }
      
      $(this).parent().toggleClass('active');
      let submenu = $(this).next('ul');
      
      if ($(this).parent().hasClass('active') && submenu.length) {
        submenu.height( submenu.prop("scrollHeight") );
      } else {
        submenu.height( 0 );
      }
    }
    
    $('.main-navbar .menu-item-has-children > a').on('click tap', submenuToggle);
    
    function closeMenuOnClick(event) {
      if(!$(event.target).parent().hasClass('menu-item-has-children')) {
        menuToggle();
      }
    }
    $('.main-navbar a').on('click', function(e) {
      if(window.matchMedia('(max-width: 1200px)').matches) {
        closeMenuOnClick(e)
        return
      }
    })
    $('footer a[href="#"]').on('click', function(e) {
      e.preventDefault();
    });
    
    // Toggle header size
    function toggleHeaderSize() {
      const header = $('header.header')
      
      $(window).scrollTop() !== 0
        ? header.addClass('small')
        : header.removeClass('small')
    }
    
    // Toggle active section
    function toggleActiveSection() {
      // const mainSections = document.querySelectorAll('main > [id]')
      const mainSections = document.querySelectorAll('main > *')
      
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if(entry.isIntersecting) {
            const sectionId = entry.target.id
            const anchorLinks = document.querySelectorAll('nav.navbar li > a[href^="#"]')
            
            anchorLinks.forEach(link => {
              link.classList.remove('current-section')
              
              if(link.getAttribute('href') === `#${sectionId}`) {
                link.classList.add('current-section')
              }
            })
          }
        })
      }, { rootMargin: "-45% 0px -45% 0px" });
      
      mainSections.forEach(section => {
        observer.observe(section)
      })
    }
    
    $(function() {
      toggleHeaderSize()
      toggleActiveSection()
    })
    
    $(window).on('scroll', function() {
      toggleHeaderSize()
    })
    
    // Smooth scroll and dynamic target
    const anchorLinks = document.querySelectorAll('.navbar li > a[href*="#"], .footer-navbar li > a[href*="#"]')
    
    anchorLinks.forEach(link => {
  		link.addEventListener('click', function (event) {
  			const targetLink = new URL(this.href)
  			const currentLink = new URL(window.location.href)
  			
  			const targetPath = targetLink.pathname.split('/').filter(path => path)
  			const currentPath = currentLink.pathname.split('/').filter(path => path)
  			
  			const isSamePath = 
  			    targetPath.length === currentPath.length &&
  			    targetPath.every((element, index) => element === currentPath[index])
        
  			if(!isSamePath) return
  			
  			event.preventDefault()
  			
  			const hash = targetLink.hash
  			const targetElement = document.querySelector(hash)
  			const isMobile = window.innerWidth < 1200
  			const hasChildItem = this.parentElement.classList.contains('menu-item-has-children')
  			
  			if(!targetElement) return
              
  			if (isMobile && hasChildItem) return
  			
  			window.scrollTo({
  				top: targetElement.offsetTop - (window.innerHeight * 0.10),
  				behavior: 'smooth'
  			})
  		})
  	})

})(jQuery);
(function($) {
  
  $(window).on('load', function () {})

})(jQuery);
(function($) {
    
    // Mapa
    const mapa = document.querySelectorAll('.map')
    
    if(mapa) {
        mapa.forEach(el => {
            let xCoordinate = el.dataset.x
            let yCoordinate = el.dataset.y
                
            const feature = [
                    new ol.Feature({
                    name: 'Nobre Comunicação Visual',
                    geometry: new ol.geom.Point(ol.proj.fromLonLat([yCoordinate, xCoordinate]))
                })
            ]
                
            new ol.Map({
                target: el,
                controls: ol.control.defaults({ attribution: false }),
                interactions: ol.interaction.defaults({mouseWheelZoom: false}),
                layers: [
                    new ol.layer.Tile({
                        title: 'Nobre Comunicação Visual',
                        className: 'bw',
                        source: new ol.source.OSM()
                    }),
                    new ol.layer.Vector({
                        source: new ol.source.Vector({
                            className: 'icon',
                            features: feature
                        }),
                        style: new ol.style.Style({
                            image: new ol.style.Icon({
                                anchor: [0.5, 1],
                                anchorXUnits: 'fraction',
                                anchorYUnits: 'fraction',
                                scale: 1,
                                src: el.dataset.marker
                            })
                        })
                    }),
                ],
                view: new ol.View({
                    center: ol.proj.fromLonLat([yCoordinate, xCoordinate]),
                    zoom: 17
                })
            });
        })
    }
    
})(jQuery);
(function($) {
  
  class Numbers {
    constructor(container) {
      this.container = container
      this.numberItems = this.container.querySelectorAll('.number-item')
      
      this.init()
    }
    
    animateNumber(data) {
      if(!data) return
      
      const value = { val: data.from }
      
      gsap.to(value, 6, {
        ease: Power1.inOut,
        val: data.to, 
        onUpdate: () => {
          const number = value.val.toFixed(data.decimal).replace('.', ',');
          data.element.innerHTML = data.prefix + number + data.sufix
        }
      })
    }
    
    animateAll() {
      this.numberItems.forEach(item => {
        const from = item.dataset.from ? +item.dataset.from : 0
        const to = item.dataset.to ? +item.dataset.to : 0
        const element = item.querySelector('.number-value')
        const decimal = item.dataset.decimal ? item.dataset.decimal : 0
        const prefix = item.dataset.prefix ? item.dataset.prefix : ''
        const sufix = item.dataset.sufix ? item.dataset.sufix : ''
        
        this.animateNumber({
          from,
          to,
          element,
          decimal,
          prefix,
          sufix
        })
      })
    }
  
    init() {
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if(entry.isIntersecting) {
              this.animateAll()
              
              observer.unobserve(entry.target)
            }
          })
        }, { threshold: [0.25] }
      )
      
      observer.observe(this.container)
    }
  }
  
  const numbers = document.querySelector('.numbers')
  
  if(numbers) {
    new Numbers(numbers);
  }

})(jQuery);
(function($) {
	
	const imagens = $('.single-servicos .slider-container');
	
	if (imagens.length) {
			
		imagens.each(function() {
			const container = $(this)
			const slider = container.find('.slider-wrapper')
			const prevArrow = container.find('.prev')
			const nextArrow = container.find('.next')
			
			slider.slick({
				slidesToShow: 2,
				slidesToScroll: 1,
				infinite: false,
				dots: false,
				arrows: true,
				prevArrow: prevArrow,
				nextArrow: nextArrow,
				responsive: [
					{
						breakpoint: 993,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							dots: false,
						}
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: false,
							dots: true,
							appendDots: container
						}
					}
				]
			})
		})
	}

})(jQuery);
(function($) {
    
    // CF7 events
	const cf7 = document.querySelectorAll('.wpcf7 form')
	
	if(cf7) {
		cf7.forEach(form => {
			form.addEventListener('submit', function() {
				this.querySelector('button[type=submit]').setAttribute('disabled', true)
			})
		
			form.addEventListener('wpcf7submit', function() {
				this.querySelector('button[type=submit]').removeAttribute('disabled')
			})
		})
	}
	
    // Mask phone input
    let phoneMaskFunction = function(val) {
    	return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    }
    
    $('input[type="tel"]').mask(phoneMaskFunction, {
    	onKeyPress: function(val, e, field, options) {
    		field.mask(phoneMaskFunction.apply({}, arguments), options);
    	}
    });
    
})(jQuery);